import "core-js/modules/es6.array.sort";
export var Mode = {
  REDIRECT: 'redirect',
  EMBED: 'embed',
  MODAL: 'modal'
};
export var AppContext = {
  MY_NERDWALLET: 'my-nerdwallet',
  EXTERNAL: 'external'
};
export var Flow = {
  BASIC: 'basic',
  CREDIT_SCORE: 'credit-score',
  ACCOUNT_AGGREGATION: 'account-aggregation',
  UNDEFINED: 'flow-name-undefined',
  PERSONAL_LOANS_PREQUAL: 'personal-loans-prequal',
  ACCOUNT_AGG: 'account-agg',
  SMB_PREQUAL: 'smb-prequal',
  // ** FOR INTERNAL USE ONLY **
  CREDIT_SCORE_NO_CAROUSEL: 'credit-score-no-carousel',
  BASIC_WITH_CAROUSEL: 'basic-with-carousel',
  CREDIT_SCORE_REGISTER_OR_SELECT_SIGN_IN: 'credit-score-register-or-select-sign-in',
  CREDIT_SCORE_BASIC_INFO_FIRST: 'credit-score-register-basic-info-first',
  ACCOUNT_AGG_WITH_AUTH: 'account-agg-with-auth'
};
export var Channel = {
  EMAIL: 'email',
  MOBILE: 'mobile',
  WEB: 'web'
};
export var Element = {
  DEFAULT: 'default',
  BANNER: 'banner',
  BUTTON: 'button',
  HYPERLINK: 'hyperlink',
  AD_UNIT: 'ad-unit',
  FILTER: 'filter',
  APPLICATION: 'application'
};
export var StepSlugs = {
  SELECT_REGISTER_TYPE: 'select-register-type',
  SIGN_IN: 'sign-in',
  REGISTER: 'register',
  THIRD_PARTY_AUTH_REQUIRE_PASSWORD: 'third-party-auth-require-password',
  GOOGLE_AUTH_REQUIRE_PASSWORD: 'google-auth-require-password',
  SECURITY_QUESTION: 'security-question',
  ACCOUNT_BLOCKED: 'account-blocked',
  BASIC_INFO: 'basic-info',
  FULL_INFO: 'full-info',
  SHORT_SSN: 'short-ssn',
  MOBILE_NUMBER: 'mobile-number',
  SMS_CODE: 'sms-code',
  VERIFICATION_QUESTIONS: 'verification-questions',
  CREDIT_PURPOSE: 'credit-purpose',
  REGISTER_OR_SELECT_SIGN_IN: 'register-or-select-sign-in'
};
export var modalClosedBy = {
  USER: 'user',
  APP: 'app',
  SUCCESS: 'success'
};
export var AuthType = {
  SIGNIN: 'signin',
  REGISTER: 'register',
  SUCCESS: 'success'
};
export var APPLE_SIGNIN_POST_MESSAGE_SOURCE = 'APPLE_SIGNIN_POST_MESSAGE_SOURCE';
export { CURRENT_TU_TOS, CURRENT_TU_TOS_VERSION, CURRENT_YODLEE_TOS_VERSION } from "./tos";
export var JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE = 'JS_AUTH_TOOLS_ASYNC_MIDDLEWARE_TYPE';
export var CreditPurposeList = ['Apply for a credit card', 'Apply for a personal loan', 'Apply for or refinance a mortgage', 'Buy or lease a car', 'Monitor my credit score and report', 'Build credit from scratch', 'Increase my credit score'];
export var stateAbbreviations = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'].sort();
export var DATE_FORMAT = {
  // @deprecated The "American" format is deprecated due to brand style updates
  AMERICAN: 'MM/DD/YYYY',
  STANDARD: 'YYYY-MM-DD'
};
export * from "./account-aggregation";
export * from "./credit-score";
export * from "./debt";
export * from "./flows";
export * from "./free-money";
export * from "./my-bills";
export * from "./transunion";
export * from "./yodlee";